// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"383bcd28","383":"81acedfd","575":"383bcd28","813":"b1d80a71"}[chunkId] + ".chunk.css";
};